import initialState from './initialState'

import {
  CONNECT,
  DISCONNECT,
  RECONNECT,
  SET_AVAILABLE_FIRMWARE,
  SET_FIRMWARE_VERSION,
  SET_FIRMWARE_UPDATE_AVAILABLE,
  DEVICE_UPDATE_FIRMWARE,
  UPDATE_FIRMWARE,
  FIRMWARE_UPDATE_COMPLETE,
  SET_BOOTLOADER_MODE
} from '../actions/actionTypes'

export default function deviceReducer(state = initialState.device, action) {
  switch (action.type) {
    case CONNECT:
      return {
        ...state,
        connected: true
      }
    case DISCONNECT:
      return {
        ...state,
        connected: false
      }
    case RECONNECT:
      return {
        ...state,
        connected: true
      }
    case SET_AVAILABLE_FIRMWARE:
      return {
        ...state,
        availableFirmware: action.version
      }
    case SET_FIRMWARE_VERSION:
      return {
        ...state,
        firmwareVersion: action.firmware,
        bootloaderVersion: action.bootloader
      }
    case SET_FIRMWARE_UPDATE_AVAILABLE:
      return {
        ...state,
        firmwareUpdateAvailable: action.updateable > 0
      }
    case DEVICE_UPDATE_FIRMWARE:
      return {
        ...state,
        updatingFirmware: true
      }
    case UPDATE_FIRMWARE:
      return {
        ...state,
        updatingFirmware: true
      }
    case FIRMWARE_UPDATE_COMPLETE:
      return {
        ...state,
        updatingFirmware: false
      }
    case SET_BOOTLOADER_MODE:
      return {
        ...state,
        bootloaderMode: action.active
      }

    default:
      return state
  }
}
